import { z } from 'zod';

export const InputSchema = z.object({
    accountId: z.number(),
    payload: z.object({
        windowLengthInDays: z.number(),
        limitType: z.enum(['rolling', 'calendar', 'lifetime']),
        calculationType: z.enum(['gross', 'net']),
    }),
});

export type InputType = z.infer<typeof InputSchema>;

const SuccessResponseSchema = z.object({});

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;

export const ErrorResponseSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
    }),
});

export type ErrorResponseType = z.infer<typeof ErrorResponseSchema>;

export const ErrorAuthResponseSchema = z.object({
    code: z.string(),
    message: z.string(),
});

export type ResponseType =
    | { responseStatus: 'success'; data: SuccessResponseType }
    | {
          responseStatus: 'error';
          data: ErrorResponseType['error'];
      }
    | {
          responseStatus: 'apiError';
          status: number;
          data?: unknown;
      };
